import { locale as localeConfig } from '@adsk/au-common-js';

export function generateClassPathname(slug: string, language?: string) {
  const langPrefix = localeConfig.generateLanguagePrefix(
    language || localeConfig.defaultURLLocale
  );

  const cleanLangPrefix = langPrefix.replace('/', '');

  const cleanSlug = slug.replace(`${cleanLangPrefix}/`, '');
  const processedSlug = langPrefix && cleanSlug ? cleanSlug : cleanSlug;

  return `/autodesk-university${langPrefix}/class/${processedSlug}`;
}
